if (!customElements.get('product-warranty')) {
  customElements.define(
    'product-warranty',
    class ProductWarranty extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.querySelector('.product-warranty__badge').addEventListener('click', () => this.open());
        this.querySelector('.product-warranty__close').addEventListener('click', () => this.close());
        // A click on the backdrop lands on the dialog element itself.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
      }

      open() {
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.dialog.close();
      }
    }
  );
}
